import React from 'react';
import {useFetchLocations} from 'hooks';
import Select, {SelectProps, SelectRefType} from 'components/common/Select';

type Props = Omit<SelectProps, 'options'>;
const CountriesSelectInternal = (
  props: Props,
  ref: React.ForwardedRef<SelectRefType>,
) => {
  const {locationsAsOptions} = useFetchLocations();

  return <Select {...props} ref={ref} options={locationsAsOptions} />;
};

export const CountriesSelect = React.forwardRef(CountriesSelectInternal) as (
  props: Props & {ref?: React.ForwardedRef<SelectRefType>},
) => ReturnType<typeof CountriesSelectInternal>;
